import { render, staticRenderFns } from "./ClaimPaymentCreate.vue?vue&type=template&id=46da4b55&"
import script from "./ClaimPaymentCreate.vue?vue&type=script&lang=js&"
export * from "./ClaimPaymentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports